

















































































import { CAT, DOG } from '@front/common/constants'
import {
  getActivePets,
  getSpeciesEmoji,
  getSpeciesLabel,
} from '@front/common/utils'
import {
  Accordeon,
  Button,
  Container,
  Divider,
  Typography,
  TYPOGRAPHY_TYPES,
} from '@front/ui'
import { computed, toRefs } from '@vue/composition-api'

import Link from '@member-area/components/Link.vue'
import PromotionalBannerContainer from '@member-area/components/PromotionalBannerContainer.vue'
import WithAccountStatusBanner from '@member-area/components/WithAccountStatusBanner.vue'
import usePet from '@member-area/core/resources/Pet/Pet.hook'
import { MEMBER_AREA_ROUTE_PET_PRODUCTS } from '@member-area/core/routes-names'

import ProductsContainer from './components/ProductsContainer.vue'

export default {
  components: {
    Button,
    Link,
    Container,
    ProductsContainer,
    Typography,
    Divider,
    Accordeon,
    PromotionalBannerContainer,
    WithAccountStatusBanner,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { id } = toRefs(props)

    const { pets } = usePet()

    const activePets = computed(() => {
      return getActivePets(pets.value)
    })

    const pet = computed(() => {
      return (
        activePets.value.find((pet) => {
          return pet.id === id.value
        }) || activePets.value[0]
      )
    })

    const petSpecies = computed(() => {
      return pet.value.species
    })

    const otherSpecies = computed(() => {
      return pet.value.species === DOG ? CAT : DOG
    })

    return {
      activePets,
      MEMBER_AREA_ROUTE_PET_PRODUCTS,
      pet,
      TYPOGRAPHY_TYPES,
      getSpeciesEmoji,
      otherSpecies,
      getSpeciesLabel,
      petSpecies,
    }
  },
}
